// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"60":"952413a12f","253":"ef01bdbdba","619":"2247f6556d"}[chunkId] + ".js";
};